import React from "react";
import { Box } from "@mui/material";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle,
} from "react-icons/fa";

const QualityRatingDisplay = ({ qualityRating }) => {
  const getRatingConfig = (rating) => {
    switch (rating) {
      case "GREEN":
        return {
          icon: FaCheckCircle,
          color: "#4caf50",
          bgColor: "rgba(76, 175, 80, 0.1)",
          className: "quality-rating-green",
        };
      case "YELLOW":
        return {
          icon: FaExclamationTriangle,
          color: "#ff9800",
          bgColor: "rgba(255, 152, 0, 0.1)",
          className: "quality-rating-yellow",
        };
      case "RED":
        return {
          icon: FaTimesCircle,
          color: "#f44336",
          bgColor: "rgba(244, 67, 54, 0.1)",
          className: "quality-rating-red",
        };
      default:
        return {
          icon: null,
          color: "transparent",
          bgColor: "transparent",
          className: "",
        };
    }
  };

  const config = getRatingConfig(qualityRating);

  if (!qualityRating || !config.icon) {
    return <Box>{qualityRating ?? ""}</Box>;
  }

  const IconComponent = config.icon;

  return (
    <Box
      className={`quality-rating ${config.className}`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        mb: 2,
        padding: "4px 12px",
        borderRadius: "16px",
        backgroundColor: config.bgColor,
        color: config.color,
        fontWeight: 500,
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "scale(1.05)",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        },
        "&.quality-rating-green:hover": {
          boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
        },
        "&.quality-rating-yellow:hover": {
          boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)",
        },
        "&.quality-rating-red:hover": {
          boxShadow: "0 4px 12px rgba(244, 67, 54, 0.3)",
        },
      }}
    >
      <IconComponent
        style={{
          fontSize: "1.2em",
          filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.1))",
        }}
      />
      <span>{qualityRating}</span>
    </Box>
  );
};
export default QualityRatingDisplay;
